import dayjs from 'dayjs';

const DATAHUB_THIRD_PARTY_ID = '23C949D6-394A-4001-94EC-B4F55E9CF850';

type BuildPowerOfAttorneyUrlOptions = {
  accountId: string | number;
  includeReturnUrl?: boolean;
  origin?: string;
};

export function buildDatahubReturnUrl(
  accountId: string | number,
  origin = window.location.origin,
) {
  return new URL(
    `/${accountId}/datahub-integration?poa=returned`,
    origin,
  ).toString();
}

export function buildDatahubPowerOfAttorneyUrl({
  accountId,
  includeReturnUrl = true,
  origin = window.location.origin,
}: BuildPowerOfAttorneyUrlOptions) {
  const url = new URL('https://eloverblik.dk/power-of-attorney');
  const fromDate = dayjs().subtract(3, 'year').format('YYYY-MM-DD');
  const toDate = dayjs().add(3, 'year').format('YYYY-MM-DD');

  const searchParams = new URLSearchParams({
    thirdPartyId: DATAHUB_THIRD_PARTY_ID,
    fromDate,
    toDate,
    customerKey: String(accountId),
  });

  const returnUrlQuery = includeReturnUrl
    ? `&returnUrl=${encodeURIComponent(buildDatahubReturnUrl(accountId, origin))}`
    : '';

  return `${url.toString()}?${searchParams.toString()}${returnUrlQuery}`;
}
